export default "__VITE_ASSET__CSPYv62o__"